
export const dashboardSteps = [

]

export const addUserSteps = [
    { element: "#firstName", intro: "First name is required for create user!" },
    { element: "#email", intro: "Email address is required for user login!" },
    { element: "#roles", intro: "Roles you given this user !" },
    { element: "#password", intro: "Password is required for user login!" },
    { element: "#confirmpassword", intro: "Confirm your password need to verify your password!" },
    { element: "#submitAddUser", hint: "Finally click here for create new user", hintPosition: "top-middle" }
]


export const instantRateSteps = [

]

export const smartQuotationSteps = [
    { element: "#customerInfoStep", intro: "Select your customer or Add new customer!" },
    { element: "#addressInfoStep", intro: "<ul><li>1. Selcect POL (Point of Loading).</li><li>2. Selcect POD (Point of Droping).</li></ul> <br/> And you can also add Pickup Address and Delivery Address" },
    { element: "#shippingInfoStep", intro: "<ul><li>1. Select Cargo Type.</li><li>2. Selcect Incoterms.</li><li>3. Select Container Type then Add Quantity and Weight(MT).</li></ul>" },
    { element: "#chargesInfoStep", intro: "<ul><li>1. Selcect Carries.</li><li>2. Add All Charges.</li></ul> <br/> <ul><li><b>Select Charge</b></li><li><b>Charge Basis</b></li><li><b>Buy Currency</b></li><li><b>Total Buy Cost</b></li><li><b>Add Markup Value</b></li></ul>" },
    { element: "#additionalInfoStep", intro: "<ul><li>1. Add Origin and Destinatiion Detention Fee.</li><li>2. Select Valid To.</li></ul>" },
    { element: "#previewSubmiBtnArea", intro: "Click on Preview Quotation"}
]


export const inquiriesListSteps = [

]

export const requestForRatesSteps = [

]

export const marketPlaceInquiriesSteps = [

]

export const quotationsListSteps = [

]

export const quotationApprovalSteps = [

]

export const fclFreightSteps = [

]

export const fclPortLocalChargesSteps = [

]

export const fclInlandChargesSteps = [

]

export const masterWaybillSteps = [

]

export const consoleSteps = [

]

export const airportLocalChargesStep = [

]

export const airlineChargesSteps = [

]

export const compareRatesSteps = [

]

export const customerListSteps = [

]

export const customerRatesSteps = [

]

export const marketingSteps = [

]

export const companySettingSteps = [

]

export const marketPlaceConfigSteps = [

]

export const integrationsConfigSteps = [

]

export const rolesConfigSteps = [

]

export const surchargeConfigSteps = [

]

export const vendorConfigSteps = [

]

export const carrierConfigSteps = [

]
